import { useCallback, useMemo } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { URLS } from 'config';
import { useApplyContext } from 'pages/Apply/context';
import { scrollToTop } from 'utils';

export interface ApplyBackButtonHook {
  onBackClick: () => void;
  title: string;
}

export default function useApplyBackButton(): ApplyBackButtonHook {
  const { id, page, goToPage } = useApplyContext();
  const { push } = useHistory();

  const getNextUrl = useCallback(
    (baseUrl: string) => {
      const url = new URL(window.location.href);
      const nextUrl = `${url.origin}${generatePath(baseUrl, {
        id,
      })}`;
      return nextUrl;
    },
    [id],
  );

  const onBackClick = useCallback(() => {
    setTimeout(() => {
      scrollToTop();
    }, 10);
    if (page === 'WELCOME') {
      push(generatePath(URLS.job, { id }), {
        page: 'CHECKOUT',
      });
      return;
    }
    if (page === 'TERMS_AND_CONDITIONS') {
      goToPage('WELCOME');
      window.history.pushState(
        window.history.state,
        '',
        getNextUrl(URLS.applyForFinance),
      );
      return;
    }
    if (page === 'YOUR_INFO') {
      goToPage('TERMS_AND_CONDITIONS');
      window.history.pushState(
        window.history.state,
        '',
        getNextUrl(URLS.applyForFinanceTermsAndConditions),
      );
    }
  }, [page, id, getNextUrl, push, goToPage]);

  const title = useMemo(() => {
    if (page === 'WELCOME') return 'Back to payment choices';
    if (page === 'TERMS_AND_CONDITIONS') return 'Back to welcome page';
    if (page === 'YOUR_INFO') return 'Back to terms and conditions';
    return 'Back';
  }, [page]);

  return {
    onBackClick,
    title,
  };
}
